module.exports = __webpack_public_path__ + "img/thumb-hero.c556ecc.png";